
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import moment from 'moment-timezone'
import 'reset-css'
import { createApp } from 'vue'
import vueDebounce from 'vue-debounce'
import VueGtag from 'vue-gtag'
import LeaderLine from 'vue3-leaderline'
import Vue3SimpleHtml2pdf from 'vue3-simple-html2pdf'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './views/router-hooks'
import '@/assets/css/tailwind.scss'
import i18n from '@/i18n'
moment.locale(i18n.global.locale)

LeaderLine.positionByWindowResize = false

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(Vue3SimpleHtml2pdf)
  .use(ElementPlus, {
    i18n: (key: string) => {
      return i18n.global.t(key)
    },
  })
  .use(vueDebounce, { defaultTime: '400ms' })
  .mount('#app')
